<template>
     <div>
            <button type="button" class="font-base-links btn btn-vigo-2-100 rounded rounded-pill minus-icon d-flex align-items-center whitespace-nowrap text-nowrap">
            <minus_icon class="me-2"></minus_icon>
                Person entfernen
            </button>
        </div>
</template>
<script setup>
    import minus_icon from "../icons/minus_icon.vue";
</script>

<style>
.minus-icon svg {
    color: #006AB2;
}
</style>